import script from "./RegisterUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterUserModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterUserModal.vue?vue&type=style&index=0&id=524e2193&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524e2193"]])

export default __exports__